import _ from 'underscore';

export const getSelection = (selection) => {
	let contentBefore = '';
	let contentAfter = '';
	const selectedText = [];

	let offsets = [selection.anchorOffset, selection.focusOffset];

	if (selection.anchorOffset > selection.focusOffset) {
		offsets = _(offsets).reverse();
	}

	if (offsets[0]) {
		let sliceBegin = 0;

		if (offsets[0] > 100) {
			sliceBegin = offsets[0] - 100;
		}

		contentBefore += `...${selection.anchorNode.textContent.slice(
			sliceBegin,
			offsets[0]
		)}`;
	}
	if (offsets[1] !== selection.focusNode.length) {
		let sliceEnd = offsets[1] + 100;

		if (offsets[1] + 100 >= selection.focusNode.length) {
			sliceEnd = selection.focusNode.length;
		}

		contentAfter = `${selection.focusNode.textContent.slice(
			offsets[1],
			sliceEnd
		)}...`;
	}

	_(selection.rangeCount).times((index) => {
		selectedText.push(selection.getRangeAt(index).toString());
	});

	return {
		begin: contentBefore,
		end: contentAfter,
		selection: selectedText.join('')
	};
};
